import Api from '@/services/Api'

export default {
    getFechas(){
        return Api().get('getFechas')
    },
    getAjustesConsol(codReporte,vigencia){
        return Api().get('getAjustesConsol/'+codReporte+'/'+vigencia)
    },
    consulAjusteOrigen(id,vigencia,idCompany,codReporte){
        return Api().get('getAjustesOrigen/'+id+'/'+vigencia+'/'+idCompany+'/'+codReporte)
    },
    consulAjusteDestino(id,vigencia,codReporte){
        return Api().get('getAjustesDestino/'+id+'/'+vigencia+'/'+codReporte)
    },
    consulAjusteOrigenById(id){
        return Api().get('getAjustesOrigenById/'+id)
    },
    updateAjusteOrigen(datos){
        return Api().put('updateAjusteOrigen',datos)
    },
    consulAjusteDestinoById(id){
        return Api().get('getAjustesDestinoById/'+id)
    },
    updateAjusteDestino(datos){
        return Api().put('updateAjusteDestino',datos)
    },
    borraAjuste(vigencia,secuencia){
        return Api().post('borraAjuste/'+vigencia+'/'+secuencia)
    },
    borraCuentasOrigen(id) {
        return Api().post('borraCuentasOrigen/'+id)
    },
    borraCuentasDestino(id) {
        return Api().post('borraCuentasDestino/'+id)
    },
    crearCuentaNueva(datos) {
        return Api().post('crear-cuenta-nueva', datos)
    },
    crearCuentaNuevaDestino(datos) {
        return Api().post('crear-cuenta-nueva-destino', datos)
    },
    getCompanyName(idCompania) {
        return Api().get('getCompanyName/' + idCompania);
    },
    getReportePrincipal(){
        return Api().get('getReportePrincipal')
    },
    ejecutarAjusteSubgrupoVigencia(vigencia){
        return Api().post('ejecutarAjusteSubgrupoVigencia/' + vigencia)
    },
    crearAjusteNoControlante(datos){
        return Api().post('crearAjusteNoControlante', datos)
    },
    getEsSubgrupo(vigencia, secuencia){
        return Api().get('getEsSubgrupo/' + vigencia + '/' + secuencia)
    },
    setEsSubgrupo(datos){
        return Api().post('setEsSubgrupo', datos)
    },
    generarAuto(vigencia){
        return Api().post('generarAuto/' + vigencia)
    },
    getEliminaciones(codReporte, vigencia, opcion) {
        return Api().get('getEliminaciones/' + codReporte + '/' + vigencia + '/' + opcion)
    },
    getEliminaOrigen(vigencia, secuencia, codReporte) {
        return Api().get('getEliminaOrigen/' + vigencia + '/' + secuencia + '/' + codReporte)
    },
    getEliminaDestino(vigencia, secuencia, codReporte) {
        return Api().get('getEliminaDestino/' + vigencia + '/' + secuencia + '/' + codReporte)
    },
    genereEliminaciones(codReporte, vigencia, secuencia) {
        return Api().post('genereEliminaciones/' + codReporte + '/' + vigencia + '/' + secuencia)
    },
    grabeAjuste(tabla, datos) {
        return Api().post('grabeAjuste/' + tabla, datos)
    },
    elimineAjuste(tabla, datos) {
        return Api().post('elimineAjuste/' + tabla, datos)
    },
    getValorAjustar(codReporte, vigencia, secuencia) {
        return Api().get('getValorAjustar/' + codReporte + '/' + vigencia + '/' + secuencia)
    },
    verificarYActualizarValoresCero(datos) {
        return Api().post('verificarYActualizarValoresCero', datos)
    },
    obtenerItemActualizado(vigencia, secuencia, cuenta, tabla) {
        return Api().get('obtenerItemActualizado/' + vigencia + '/' + secuencia + '/' + cuenta + '/' + tabla)
    },
    grabeContraAjuste(datos) {
        return Api().post('grabeContraAjuste', datos)
    },
    actualizarValoresCero(tipo, valores) {
        return Api().post('actualizarValoresCero/' + tipo, valores)
    }
}